<micro-select-combo #sel
              placeholder="SMS Carrier Type"
              [mode]="mode"
              [(id)]="smsCarrierTypeId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              [blur]="onTouched"
>
</micro-select-combo>
